import APIManager from 'modules/common/apiManager';
import { isAccess } from 'modules/common/utils';
import {
  Alert,
  Button,
  ColumnTitle,
  ControlLabel,
  FormColumn,
  FormControl,
  FormGroup,
  FormWrapper,
  InfoWrapper,
  ModalFooter,
} from 'modules/theme';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select-plus';
import styled from 'styled-components';
import { Logger } from '../../../../../logger';
import { globalStateSelector } from '../../../../../store/selector';
import { ButtonCommonTheme } from '../../../../theme';
import {
  ModalForm,
  ModalFormContainer,
} from '../../../../theme/theme1/common/styles/main';

const logger = new Logger('Contact List Private Add Edit');

class ContactListPrivateAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Contact`;
    this.moduleUrl = `contact/contact-list/info`;
    this.rejectList = [
      '_id',
      'phone_number',
      'publicInfo',
      'updateBy',
      'update_at',
      'listId',
      'listName',
    ];
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    this.setData(this.props.editData);
    this.renderColumnData(this.props.editData);
  }

  componentDidMount() {
    if (this.props.editData) {
      this.setState({ disabled: !isAccess(this.props.access, 'edit') });
    }
  }
  getData(editData = '', type = 'mobile') {
    editData = editData || {};
    if (type == 'mobile') {
      return editData.phone_number ? editData.phone_number : '';
    }
    if (type == 'countryCode') {
      return editData.mobile_numbers &&
        editData.mobile_numbers[0] &&
        editData.mobile_numbers[0].country_code
        ? editData.mobile_numbers[0].country_code
        : '';
    } else {
      return '';
    }
  }
  objectToArray(obj) {
    let result = [];
    for (const prop in obj) {
      if (
        prop != 'phone_number' &&
        prop != '_id' &&
        prop != 'update_at' &&
        prop != 'updateBy' &&
        prop != 'updateBy'
      ) {
        if (prop && obj[prop]) {
          result.push({ key: prop, value: obj[prop] });
        }
      }
    }
    return result;
  }
  setData(editData = '') {
    editData = editData || {};
    this.state = {
      mobileNumber: this.getData(editData) || '',
      countryCode: this.getData(editData, 'countryCode') || '',
      info: '',
      contactListName: editData.contactListName || '',
      privateInfo: this.objectToArray(editData || {}),
      oldData: [],
      newData: [],
      oldColumn: [],
    };
  }

  renderColumnData(editData = '') {
    editData = editData || {};
    if (this.props.listField) {
      this.props.listField.map((el) => {
        let val = editData[el] || '';
        this.state.oldColumn.push({ key: el, value: val });
      });
    }
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      if (data && data.message) {
        Alert.success(`${this.moduleName} updated successfully.`);
      }
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      if (data && data.message) {
        Alert.error(`${data.message}`);
      } else {
        Alert.error(`Something Wrong Happned`);
      }
    }
  }

  resetAllData() {
    this.setState({
      mobileNumber: '',
      countryCode: '',
    });
  }

  saveData(e) {
    this.setState({ disableSubmit: true });
    let keys = this.state.oldColumn.map((o) => o.key);
    let values = this.state.oldColumn.map((o) => o.value);
    let obj = {};
    for (let index = 0; index < keys.length; index++) {
      obj[keys[index]] = values[index];
    }
    let newKeys = this.state.newData.map((o) => o.key);
    let newValues = this.state.newData.map((o) => o.value);
    let objc = {};
    for (let index = 0; index < newKeys.length; index++) {
      objc[newKeys[index]] = newValues[index];
    }
    let mainData = {};
    mainData = { ...obj, ...objc };
    e.preventDefault();

    let _this = this;

    let tData = {
      mobileNumber: this.state.mobileNumber,
      countryCode: '91',
      info: mainData,
      contactListName: this.props.contactId,
    };
    if (this.props.editData) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        {
          infoId: this.props.editData._id,
          mobileNumber: this.state.mobileNumber,
          countryCode: '91',
          info: mainData,
          contactListName: this.props.contactId,
        },
        (data) => {
          if (data) {
            _this.setData();
            _this.props.closeModal(true, mainData);
            Alert.success(`${this.moduleName} updated successfully.`);
            _this.setState({ disableSubmit: false });
            logger.log('calling get list in save Data in update');
            this.props.getList(1, '', this.props.contactId);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
          _this.setState({ disableSubmit: false });
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          Alert.success(`${this.moduleName} created successfully`);
          _this.setState({ disableSubmit: false });
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
          logger.log('calling get list in create');
          this.props.getList(1, '', this.props.contactId);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  addField() {
    this.state.newData.push({ key: '', value: '' });
    this.setState({ newData: this.state.newData });
  }

  removeField(i) {
    this.state.newData.splice(i, 1);
    this.setState({ newData: this.state.newData });
  }

  createForm() {
    return this.state.newData.map((el, i) => (
      <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Name', {
              placeholder: 'Name',
              defaultValue: '',
              autoFocus: false,

              required: true,
              id: 'name',
              value: el.key,
              onChange: (e) => {
                if (this.state.newData && this.state.newData[i]) {
                  this.state.newData[i].key =
                    e.target.value && e.target.value.trim() == ''
                      ? ''
                      : e.target.value;
                  // .charAt(0).toUpperCase() + e.target.value.slice(1);
                  this.setState({ newData: this.state.newData });
                }
              },
            })}
          </FormColumn>

          <FormColumn style={{ paddingRight: '40px' }}>
            {this.renderFormGroup('Value', {
              defaultValue: '',
              placeholder: 'Value',
              autoFocus: false,
              required: true,
              id: 'value',
              value: el.value,
              onChange: (e) => {
                if(e.target.value == ' ') {
                  return false;
                }
                if (this.state.newData && this.state.newData[i]) {
                  this.state.newData[i].value = e.target.value;
                  this.setState({ newData: this.state.newData });
                }
              },
            })}
          </FormColumn>
        </FormWrapper>
        <Button
          btnStyle='link'
          size='small'
          onClick={this.removeField.bind(this, i)}
          icon='cancel-1'
        />
      </div>
    ));
  }

  renderFields() {
    return (
      <ColumnTitle>
        <InfoWrapper style={{ marginBottom: '18px' }}>
          Add Customer Info
        </InfoWrapper>
        {this.createForm()}
        {/* <Button
          onClick={this.addField.bind(this)}
          btnStyle="default"
          size="small"
          icon="add"
          className="darkblue-btn p-3"
        > */}
        {/* <ButtonPadding> */}
        {/* <Button
            className="lightblue-btn"
            btnStyle="cancel"
            onClick={() => this.addField()}
            size="xl"

            >
            <span class="material-symbols-outlined mr-3">add_circle</span>
            Add
          </Button> */}
        <ButtonCommonTheme type='add' addOnClick={() => this.addField()} />
        {/* </ButtonPadding> */}
        {/* <input type='button' value='add more' onClick={this.addClick.bind(this)} /> */}
      </ColumnTitle>
    );
  }

  generateParams(tData) {
    return tData.map((tData) => ({
      value: tData._id,
      label: tData.emoji + ' ' + tData.phone_code,
    }));
  }

  renderCountryCode() {
    return (
      <FormGroup>
        {/* <ControlLabel>Country Code</ControlLabel> */}
        <Select
          placeholder='Country Code'
          onChange={(item) => {
            if (item) {
              this.setState({ countryCode: item.value || '' });
            } else {
              this.setState({ countryCode: '' });
            }
          }}
          value={this.state.countryCode}
          options={this.generateParams(this.props.CountryList)}
          style={{ width: '125px' }}
        />
      </FormGroup>
    );
  }

  render() {
    const { modalType } = this.props;
    const exceptThisSymbols = ['e', 'E', '-', '.', '+'];
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          {/* <form onSubmit={e => this.saveData(e)}> */}
          {/* <ColumnTitle style={{ borderBottom: 'none', padding: '0px' }}>
              <InfoWrapper style={{ marginBottom: '18px' }}>
                Mobile Number
              </InfoWrapper>
            </ColumnTitle> */}
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('Phone Number', {
                defaultValue: '',
                min: 0,
                type: 'number',
                placeholder: 'Phone Number',
                autoFocus: true,
                disabled:
                  this.props.editData && this.props.editData._id ? true : false,
                required: true,
                id: 'mobileNumber',
                value: this.state.mobileNumber,
                onKeyDown: (e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                },
                onChange: (e) => {
                  if (e.target.value.length > 20) {
                    return false;
                  }
                  this.setState({ mobileNumber: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          {this.props.editData && this.props.editData._id
            ? this.state.oldColumn.map((el, i) => (
                <div key={i}>
                  <FormWrapper>
                    <FormColumn>
                      {typeof el.key == 'string' &&
                        this.renderFormGroup(el.key, {
                          defaultValue: '',
                          autoFocus: false,
                          disabled: this.state.disabled,
                          id: 'name',
                          value: typeof el.value == 'string' ? el.value : '',
                          onChange: (e) => {
                            if (
                              this.state.oldColumn &&
                              this.state.oldColumn[i]
                            ) {
                              this.state.oldColumn[i].value = e.target.value;
                              this.setState({
                                oldColumn: this.state.oldColumn,
                              });
                            }
                          },
                        })}
                    </FormColumn>
                  </FormWrapper>
                </div>
              ))
            : this.state.oldColumn.map((el, i) => {
                if (
                  this.rejectList &&
                  el.key &&
                  this.rejectList.indexOf(el.key) > -1
                ) {
                  return <React.Fragment />;
                }
                return (
                  <div key={i}>
                    <FormWrapper>
                      <FormColumn>
                        {typeof el.key == 'string' &&
                          this.renderFormGroup(el.key, {
                            defaultValue: '',
                            autoFocus: false,
                            id: 'name',
                            value: typeof el.value == 'string' ? el.value : '',
                            onChange: (e) => {
                              if (
                                this.state.oldColumn &&
                                this.state.oldColumn[i]
                              ) {
                                this.state.oldColumn[i].value = e.target.value;
                                this.setState({
                                  oldColumn: this.state.oldColumn,
                                });
                              }
                            },
                          })}
                      </FormColumn>
                    </FormWrapper>
                  </div>
                );
              })}
          {!this.state.disabled && this.renderFields()}
          {/* </form> */}
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <Button
            className='grey-btn'
            btnStyle='cancel'
            onClick={() => this.props.closeModal()}
            size='xl'
          >
            Cancel
          </Button>
          {!this.state.disabled && (
            <Button
              className='blue-btn'
              type='submit'
              btnStyle='default'
              size='xl'
              style={{ float: 'right' }}
              disabled={this.state.disableSubmit}
            >
              {this.props.editData && this.props.editData._id
                ? 'Update'
                : 'Add'}
            </Button>
          )}
        </ModalFooter>
      </ModalForm>
    );
  }
}

ContactListPrivateAddEdit.propTypes = {
  group: PropTypes.array,
};

ContactListPrivateAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

const ButtonPadding = styled.div`
  .blue-btn {
    padding: 8px !important;
  }
`;

const stateToProps = (state) => ({
  access: globalStateSelector.getPermission(state, 'contact'),
});

export default connect(stateToProps)(ContactListPrivateAddEdit);



// WEBPACK FOOTER //
// src/modules/screens/settings/ContactListPrivate/components/ContactListPrivateAddEdit.js